import {useEffect} from 'react';
import isDevelopment from 'utils/development';

const OVERLAY_MOUNT_ID = '#page';

export const getPageContentContainer = (): HTMLElement => {
    let element: HTMLElement | null;

    if (isDevelopment()) {
        element = document.body;
    } else {
        element = document.querySelector(
            OVERLAY_MOUNT_ID,
        ) as HTMLElement | null;
        if (!element) throw new Error(`${OVERLAY_MOUNT_ID} was undefined!`);
    }

    return element;
};
export default getPageContentContainer;

export const usePreventBackgroundScroll = (isOpen: boolean): void => {
    useEffect(() => {
        const {scrollY} = window;

        if (isOpen) {
            const element = getPageContentContainer();
            element.style.setProperty('top', `-${scrollY}px`);
            element.style.setProperty('position', 'fixed');
            element.style.setProperty('width', '100%');
        }

        return () => {
            const element = getPageContentContainer();
            element.style.removeProperty('top');
            element.style.removeProperty('position');
            element.style.removeProperty('width');

            window.scrollTo(0, scrollY);
        };
    }, [isOpen]);
};
